// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

html, body {
	height: 100%;
	font-family: "Inter", sans-serif;
	font-size: 14px;
    color: #16325c;
	overflow: hidden;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

code {
	font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.header {
    display: flex;
    font-size: 18px;
    padding: 16px;
    color: #ffffff;
    font-weight: 600;
    background: linear-gradient(90deg, rgba(45,172,240,1) 0%, rgb(16, 127, 207) 50%, rgb(2, 93, 177) 100%);
    align-items: center;
}

.header-logo {
    width: 15%; 
    height: auto; 
    margin-right: 10px;
  }


.message-container {
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    padding: 16px 16px 90px;
    height: calc(100vh - 55px);
  }

.message {
	max-width: 85%;
	margin-bottom: 10px;
}

.user-message {
	align-self: flex-end;
	background-color: rgb(45, 172, 240);
	color: #ffffff;
	padding: 10px;
	border-radius: 20px 20px 2px 20px;
	max-width: 85%;
	text-transform: capitalize;
}

.system-message {
	align-self: flex-start;
	background-color: rgba(45, 172, 240, 0.05);
	border: 1px solid rgba(45, 172, 240, 0.1);
	padding: 12px 20px;
	border-radius: 20px 20px 20px 2px;
	white-space: pre-wrap;
    max-height: 600px;
}

.input-container {
    display: flex;
    align-items: center;
    background-color: #f4f4f4;
    position: fixed;
    bottom: 20px;
    border-radius: 25px;
    left: 20px;
    right: 20px;
    padding: 0 10px 0 10px;
  }

.input-container:focus-within {
	outline: none;
}

.inputForm {
	display: flex;
	align-items: center;
	flex: 1 1;
}

.form-control {
	flex: 1 1;
    margin-top: 12px;
}

.form-in {
	font-family: "Inter", sans-serif;
	border: none;
	font-size: 13px;
	width: 100%;
    font-weight: 400;
	padding: 8px;
    color: #16325c;
    margin-bottom: 8px;
    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.02);
	border-radius: 6px;
}

.form-in::placeholder {
	font-size: 13px;
    color: #16325c;
    font-weight: 300;
}

.button-group {
	display: flex;
	align-items: center;
	margin-top: 10px;
}

.btn {
	border: none;
	font-size: 14px;
	cursor: pointer;
	padding: 8px 20px;
	transition: background-color 300ms ease-out;
	border-radius: 4px;
	font-weight: 500;
	line-height: 1;
}

.btn-full {
	width: 100%;
}

.btn-primary {
	background-color: rgb(45, 172, 240);
	color: #ffffff;
	margin-left: 6px;
}

.btn-primary:hover {
	background-color: #004895;
}

.btn-secondary {
	background-color: #d34a51;
	color: #ffffff;
}

.btn-secondary:hover {
	background-color: #8a010f;
}

.form-group {
	display: flex;
}

.questionlabel {
	font-size: 14px;
	margin-bottom: 5px;
}

.menu-button-container {
	position: relative;
}

.menu-button {
	border: none;
	cursor: pointer;
	color: #ffffff;
    width: 36px;
    height: 36px;
    padding: 2px 0 0;
	background: rgb(45, 172, 240);
	border-radius: 50%;
}

.menu-button span {
    font-size: 22px;
    transition: transform 200ms ease-out;
}

.menu-button.open span {
    transform: rotate(45deg);
}

.menu-options {
	position: absolute;
	left: 0;
	bottom: 100%;
    margin-bottom: 1px;
	z-index: 10;
	width: 160px;
	background: #ffffff;
    border: 1px solid #ededed;
    box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.06);
	border-radius: 6px;
}

.menu-option {
    font-family: 'Inter';
    font-size: 13px;
	color: #333;
	cursor: pointer;
    padding: 10px 12px;
	transition: all 200ms ease-out;
    /* remove button defaults */
    width: 100%;
    border: none;
    outline: none;
    text-align: left;
    background: none;
}

.followUpButton{
    font-family: 'Inter';
    font-size: 14px;
	color: #ffffff;
	cursor: pointer;
    margin-top: 10px;
    padding: 10px;
	transition: all 200ms ease-out;
    background-color: rgb(45, 172, 240);
    border: 1px solid #ededed;
    box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.06);
	border-radius: 6px;
    /* remove button defaults */
    width: 100%;
    border: none;
    outline: none;
}

.chiclet-container {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: -5px;
    margin-left: 2px;
    margin-bottom: 7px;
    width: 85%;
}
  
.chiclet {
    padding: 7px 10px;
    flex: 1 1 48%;
    font-size: 11px;
    background-color: rgba(45, 172, 240,0.06);
    border: 1px solid rgba(45, 172, 240,0.3);
    box-shadow: 0 4px 4px 2px rgba(45, 172, 240, 0.1);
    border-radius: 15px;
    cursor: pointer;
}

.chiclet:hover {
    background-color: rgba(45, 172, 240,0.2);
}

.menu-option:hover {
	background: rgba(45, 172, 240, 0.1);
}

.menu-option:disabled{
    opacity: 0.4;
}

.micButton {
	background-color: transparent;
	color: rgb(45, 172, 240);
	border: none;
	padding: 10px 5px;
	font-size: 14px;
	border-radius: 0px;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.micButton:disabled {
    opacity: 0.4;
}

.inputButton {
	background-color: transparent;
	color: rgb(45, 172, 240);
	border: none;
	padding: 10px 5px;
	font-size: 14px;
	border-radius: 0px;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.inputButton:disabled {
    opacity: 0.4;
}

.iframe-container {
    position: relative;
    width: 125%;
    height: 600px;
    transform: scale(0.8);
    transform-origin: 0 0;
    border: 2px solid rgb(45, 172, 240,0.5);
    border-radius: 5px;
  }
  

  

.form-control-input {
	flex: 1 1;
	padding: 10px;
	font-size: 14px;
	background-color: #f4f4f4;
	border: none;
}

.form-control-input:disabled {
	opacity: 0.4;
}

.form-control-input:focus {
	outline: none;
}

.form-control-input::placeholder{
    color: #16325c;
}

/* Date-time input style */
.form-control-input[type="datetime-local"] {
    appearance: none;
    background-color: #f4f4f4;
    padding: 10px;
    font-size: 14px;
    border: none;
    color: #16325c;
    flex: 1 1;
}

/* Adjust for browsers that don't fully support appearance */
.form-control-input[type="datetime-local"]::-webkit-inner-spin-button,
.form-control-input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}

/* For Firefox */
.form-control-input[type="datetime-local"]::-moz-inner-spin-button {
    display: none;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,gCAAgC;CAChC,eAAe;IACZ,cAAc;CACjB,gBAAgB;CAChB,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC,+EAA+E;AAChF;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,sGAAsG;IACtG,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;;AAGF;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;AAEF;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,mCAAmC;CACnC,cAAc;CACd,aAAa;CACb,iCAAiC;CACjC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;CACtB,0CAA0C;CAC1C,yCAAyC;CACzC,kBAAkB;CAClB,iCAAiC;CACjC,qBAAqB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,sBAAsB;EACxB;;AAEF;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAO;AACR;;AAEA;CACC,SAAO;IACJ,gBAAgB;AACpB;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,eAAe;CACf,WAAW;IACR,gBAAgB;CACnB,YAAY;IACT,cAAc;IACd,kBAAkB;IAClB,2CAA2C;CAC9C,kBAAkB;AACnB;;AAEA;CACC,eAAe;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,2CAA2C;CAC3C,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mCAAmC;CACnC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,cAAc;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;CACnB,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,YAAY;IACT,kBAAkB;CACrB,WAAW;CACX,YAAY;CACZ,mBAAmB;IAChB,yBAAyB;IACzB,6CAA6C;CAChD,kBAAkB;AACnB;;AAEA;IACI,oBAAoB;IACpB,eAAe;CAClB,WAAW;CACX,eAAe;IACZ,kBAAkB;CACrB,8BAA8B;IAC3B,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;CAClB,cAAc;CACd,eAAe;IACZ,gBAAgB;IAChB,aAAa;CAChB,8BAA8B;IAC3B,mCAAmC;IACnC,yBAAyB;IACzB,6CAA6C;CAChD,kBAAkB;IACf,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,aAAW;IACX,eAAe;IACf,yCAAyC;IACzC,wCAAwC;IACxC,iDAAiD;IACjD,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;CACC,mCAAmC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;CACC,6BAA6B;CAC7B,wBAAwB;CACxB,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,sCAAsC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;CACC,6BAA6B;CAC7B,wBAAwB;CACxB,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,sCAAsC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,uCAAuC;IACvC,kBAAkB;EACpB;;;;;AAKF;CACC,SAAO;CACP,aAAa;CACb,eAAe;CACf,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IAGI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,cAAc;IACd,SAAO;AACX;;AAEA,4DAA4D;AAC5D;;IAEI,aAAa;IACb,wBAAwB;AAC5B;;AAEA,gBAAgB;AAChB;IACI,aAAa;AACjB","sourcesContent":["* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\nhtml, body {\n\theight: 100%;\n\tfont-family: \"Inter\", sans-serif;\n\tfont-size: 14px;\n    color: #16325c;\n\toverflow: hidden;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.header {\n    display: flex;\n    font-size: 18px;\n    padding: 16px;\n    color: #ffffff;\n    font-weight: 600;\n    background: linear-gradient(90deg, rgba(45,172,240,1) 0%, rgb(16, 127, 207) 50%, rgb(2, 93, 177) 100%);\n    align-items: center;\n}\n\n.header-logo {\n    width: 15%; \n    height: auto; \n    margin-right: 10px;\n  }\n\n\n.message-container {\n    display: flex;\n    overflow-y: auto;\n    flex-direction: column;\n    padding: 16px 16px 90px;\n    height: calc(100vh - 55px);\n  }\n\n.message {\n\tmax-width: 85%;\n\tmargin-bottom: 10px;\n}\n\n.user-message {\n\talign-self: flex-end;\n\tbackground-color: rgb(45, 172, 240);\n\tcolor: #ffffff;\n\tpadding: 10px;\n\tborder-radius: 20px 20px 2px 20px;\n\tmax-width: 85%;\n\ttext-transform: capitalize;\n}\n\n.system-message {\n\talign-self: flex-start;\n\tbackground-color: rgba(45, 172, 240, 0.05);\n\tborder: 1px solid rgba(45, 172, 240, 0.1);\n\tpadding: 12px 20px;\n\tborder-radius: 20px 20px 20px 2px;\n\twhite-space: pre-wrap;\n    max-height: 600px;\n}\n\n.input-container {\n    display: flex;\n    align-items: center;\n    background-color: #f4f4f4;\n    position: fixed;\n    bottom: 20px;\n    border-radius: 25px;\n    left: 20px;\n    right: 20px;\n    padding: 0 10px 0 10px;\n  }\n\n.input-container:focus-within {\n\toutline: none;\n}\n\n.inputForm {\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 1;\n}\n\n.form-control {\n\tflex: 1;\n    margin-top: 12px;\n}\n\n.form-in {\n\tfont-family: \"Inter\", sans-serif;\n\tborder: none;\n\tfont-size: 13px;\n\twidth: 100%;\n    font-weight: 400;\n\tpadding: 8px;\n    color: #16325c;\n    margin-bottom: 8px;\n    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.02);\n\tborder-radius: 6px;\n}\n\n.form-in::placeholder {\n\tfont-size: 13px;\n    color: #16325c;\n    font-weight: 300;\n}\n\n.button-group {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 10px;\n}\n\n.btn {\n\tborder: none;\n\tfont-size: 14px;\n\tcursor: pointer;\n\tpadding: 8px 20px;\n\ttransition: background-color 300ms ease-out;\n\tborder-radius: 4px;\n\tfont-weight: 500;\n\tline-height: 1;\n}\n\n.btn-full {\n\twidth: 100%;\n}\n\n.btn-primary {\n\tbackground-color: rgb(45, 172, 240);\n\tcolor: #ffffff;\n\tmargin-left: 6px;\n}\n\n.btn-primary:hover {\n\tbackground-color: #004895;\n}\n\n.btn-secondary {\n\tbackground-color: #d34a51;\n\tcolor: #ffffff;\n}\n\n.btn-secondary:hover {\n\tbackground-color: #8a010f;\n}\n\n.form-group {\n\tdisplay: flex;\n}\n\n.questionlabel {\n\tfont-size: 14px;\n\tmargin-bottom: 5px;\n}\n\n.menu-button-container {\n\tposition: relative;\n}\n\n.menu-button {\n\tborder: none;\n\tcursor: pointer;\n\tcolor: #ffffff;\n    width: 36px;\n    height: 36px;\n    padding: 2px 0 0;\n\tbackground: rgb(45, 172, 240);\n\tborder-radius: 50%;\n}\n\n.menu-button span {\n    font-size: 22px;\n    transition: transform 200ms ease-out;\n}\n\n.menu-button.open span {\n    transform: rotate(45deg);\n}\n\n.menu-options {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 100%;\n    margin-bottom: 1px;\n\tz-index: 10;\n\twidth: 160px;\n\tbackground: #ffffff;\n    border: 1px solid #ededed;\n    box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.06);\n\tborder-radius: 6px;\n}\n\n.menu-option {\n    font-family: 'Inter';\n    font-size: 13px;\n\tcolor: #333;\n\tcursor: pointer;\n    padding: 10px 12px;\n\ttransition: all 200ms ease-out;\n    /* remove button defaults */\n    width: 100%;\n    border: none;\n    outline: none;\n    text-align: left;\n    background: none;\n}\n\n.followUpButton{\n    font-family: 'Inter';\n    font-size: 14px;\n\tcolor: #ffffff;\n\tcursor: pointer;\n    margin-top: 10px;\n    padding: 10px;\n\ttransition: all 200ms ease-out;\n    background-color: rgb(45, 172, 240);\n    border: 1px solid #ededed;\n    box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.06);\n\tborder-radius: 6px;\n    /* remove button defaults */\n    width: 100%;\n    border: none;\n    outline: none;\n}\n\n.chiclet-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    margin-top: -5px;\n    margin-left: 2px;\n    margin-bottom: 7px;\n    width: 85%;\n}\n  \n.chiclet {\n    padding: 7px 10px;\n    flex: 1 48%;\n    font-size: 11px;\n    background-color: rgba(45, 172, 240,0.06);\n    border: 1px solid rgba(45, 172, 240,0.3);\n    box-shadow: 0 4px 4px 2px rgba(45, 172, 240, 0.1);\n    border-radius: 15px;\n    cursor: pointer;\n}\n\n.chiclet:hover {\n    background-color: rgba(45, 172, 240,0.2);\n}\n\n.menu-option:hover {\n\tbackground: rgba(45, 172, 240, 0.1);\n}\n\n.menu-option:disabled{\n    opacity: 0.4;\n}\n\n.micButton {\n\tbackground-color: transparent;\n\tcolor: rgb(45, 172, 240);\n\tborder: none;\n\tpadding: 10px 5px;\n\tfont-size: 14px;\n\tborder-radius: 0px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s ease;\n}\n\n.micButton:disabled {\n    opacity: 0.4;\n}\n\n.inputButton {\n\tbackground-color: transparent;\n\tcolor: rgb(45, 172, 240);\n\tborder: none;\n\tpadding: 10px 5px;\n\tfont-size: 14px;\n\tborder-radius: 0px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s ease;\n}\n\n.inputButton:disabled {\n    opacity: 0.4;\n}\n\n.iframe-container {\n    position: relative;\n    width: 125%;\n    height: 600px;\n    transform: scale(0.8);\n    transform-origin: 0 0;\n    border: 2px solid rgb(45, 172, 240,0.5);\n    border-radius: 5px;\n  }\n  \n\n  \n\n.form-control-input {\n\tflex: 1;\n\tpadding: 10px;\n\tfont-size: 14px;\n\tbackground-color: #f4f4f4;\n\tborder: none;\n}\n\n.form-control-input:disabled {\n\topacity: 0.4;\n}\n\n.form-control-input:focus {\n\toutline: none;\n}\n\n.form-control-input::placeholder{\n    color: #16325c;\n}\n\n/* Date-time input style */\n.form-control-input[type=\"datetime-local\"] {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-color: #f4f4f4;\n    padding: 10px;\n    font-size: 14px;\n    border: none;\n    color: #16325c;\n    flex: 1;\n}\n\n/* Adjust for browsers that don't fully support appearance */\n.form-control-input[type=\"datetime-local\"]::-webkit-inner-spin-button,\n.form-control-input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n}\n\n/* For Firefox */\n.form-control-input[type=\"datetime-local\"]::-moz-inner-spin-button {\n    display: none;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
